import { useCallback, useEffect, useState } from 'react';
import { StopsService } from '../../services/preventive-stops/stopsService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage preventive stop status data fetching and transformation.
* ES: Hook para gestionar la obtención y transformación de datos del estado de paradas preventivas.
----------------------------------------------------------------------------------------*/

const useStopsStatus = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999, 
        filter_filters: { ...initialFilters } 
    });

    const fetchStopsStatus = useCallback(async () => {
        try {
            const service = new StopsService();
            const response = await service.listForSelectStatusStops({ limit: 999999 });
            const fetchedData = response.getResponseData().data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; color: string; }) => ({
                    value: data.id,
                    label: data.name,
                    color: data.color,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching statuses:', error);
        }
    }, []);

    useEffect(() => {
        fetchStopsStatus();
    }, []);

    const getStopsStatusList = () => {
        return data;
    };

    return { fetchStopsStatus, getStopsStatusList };
}

export default useStopsStatus;